// Real reviews data imported from Judge.me export
export interface Review {
  id: string;
  title: string;
  body: string;
  rating: number;
  reviewerName: string;
  createdAt: string;
  verified: boolean;
  productHandle: string;
  productTitle?: string;
  pictureUrls: string[];
}

export const reviewsData: Review[] = [
  // calmi-tree™
  {
    id: "review-69be465f",
    title: "",
    body: "Perfect fit and it's been on for 3 days, i already feel the difference.",
    rating: 5,
    reviewerName: "Clinton S.",
    createdAt: "2025-08-23",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A2dbcec363ad3454a996662bd35f82159a.jpg"]
  },
  {
    id: "review-071f67f2",
    title: "",
    body: "Stunning, arrived beautifully packaged and not after a long time, about two weeks. A little big but I made a cross and it's cute.",
    rating: 4,
    reviewerName: "Tabetha R.",
    createdAt: "2025-08-12",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A3089499024924b3f8f613ab7b557aa45F.jpg"]
  },
  {
    id: "review-1a512056",
    title: "",
    body: "Very nice quality, thick, it is wide and easily adjustable on the wrist.",
    rating: 5,
    reviewerName: "Dudley K.",
    createdAt: "2025-11-11",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/Ab762f50d8f984085aed322ab928466d0C.jpg"]
  },
  {
    id: "review-85115f03",
    title: "",
    body: "The opening of the bracelet - it is a very lovely experience! Feels as top quality product, considering the price!",
    rating: 4,
    reviewerName: "Dorothea S.",
    createdAt: "2025-11-12",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A8e2c14a5bcc1460ba9ce1d690460531cL.jpg"]
  },
  {
    id: "review-0d57f67d",
    title: "",
    body: "Great product, very beautiful and durable.",
    rating: 5,
    reviewerName: "Rebbeca M.",
    createdAt: "2025-10-27",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/Afc58d0c8efaf43198fe038c8a777d463i.jpg"]
  },
  {
    id: "review-902a8eca",
    title: "",
    body: "It's very nice, it's thick and feels high quality... as for the benefits, I would need to use it for a while.",
    rating: 5,
    reviewerName: "Lani B.",
    createdAt: "2025-09-18",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A9dc107c8d95c4ee28a66f789fa5d672aH.jpg"]
  },
  {
    id: "review-84bb354d",
    title: "",
    body: "Men's bracelet, appears to be pure copper.",
    rating: 5,
    reviewerName: "Charlesetta R.",
    createdAt: "2025-07-17",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A42eabaf9a2e54d9aae5a13ab4387f580H.jpg"]
  },
  {
    id: "review-5222686a",
    title: "",
    body: "Super seller. Fast shipping and delivery. Fantastic item. More than expected.",
    rating: 5,
    reviewerName: "Porter B.",
    createdAt: "2025-09-13",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/Afb4be6d028b047719b7726b974c67847D.jpg"]
  },
  {
    id: "review-cde36daa",
    title: "",
    body: "Super beautiful and well packaged. Very fast shipping.",
    rating: 5,
    reviewerName: "Maisie C.",
    createdAt: "2025-12-07",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A3ed2e08592f647e39d0ae9a2bb79cde1L.jpg"]
  },
  {
    id: "review-4566bb6d",
    title: "",
    body: "Excellent quality",
    rating: 5,
    reviewerName: "Derick Q.",
    createdAt: "2025-09-03",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/Af4c9eb797f524d038b6064ca1a7a80a6E.jpg"]
  },
  {
    id: "review-1bb626e4",
    title: "",
    body: "Very good quality and fits well. Fast shipping.",
    rating: 5,
    reviewerName: "Bibi S.",
    createdAt: "2026-01-09",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A1efea1519e484472b8f9a9ba181cde1ar.jpg"]
  },
  {
    id: "review-73bc9f50",
    title: "",
    body: "Excellent",
    rating: 5,
    reviewerName: "Albert H.",
    createdAt: "2025-08-25",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/Abf645e1c2fb4434ba80b7694530884c4m.jpg"]
  },
  {
    id: "review-02bac107",
    title: "",
    body: "Very very good, we will see the effect later and it's copper.",
    rating: 5,
    reviewerName: "Irena K.",
    createdAt: "2025-12-14",
    verified: true,
    productHandle: "calmi-tree™-tree-of-life-copper-magnetic-cuff-bracelet-for-men-and-women",
    pictureUrls: ["https://ae01.alicdn.com/kf/A7bf7e98ccc474fdf93f3472f77eb024f5.jpg"]
  },
  
  // calmi-ring™
  {
    id: "review-d94f5aa1",
    title: "",
    body: "Great copper ring with magnets. The copper in combination with the magnets works well for my artritis. Easy to adjust to your size and they look fashionable. I really like them!",
    rating: 5,
    reviewerName: "Alton H.",
    createdAt: "2025-06-30",
    verified: true,
    productHandle: "calmi-ring™-adjustable-copper-magnetic-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A9c1aa9d55531431fa1754c42e08f86a2v.jpg"]
  },
  
  // calmi-set™
  {
    id: "review-ccd7a108",
    title: "",
    body: "Beautiful and of good quality! Just like the photo! I loved it! I recommend it 100%.",
    rating: 5,
    reviewerName: "Ulysses S.",
    createdAt: "2025-07-30",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A6b9c3cfc4acd407ab42ef32bad15e7131.jpg"]
  },
  {
    id: "review-bcfa60d9",
    title: "",
    body: "Happy with my order, thank you. It is as described in colour, shape, size and material.",
    rating: 5,
    reviewerName: "Taylor C.",
    createdAt: "2025-11-07",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/Acadc378fb30045b6aafe72846c841bd3z.jpg"]
  },
  {
    id: "review-83aa6ede",
    title: "",
    body: "This is super beautiful... The bracelet and the ring, thank you very much and it arrived super fast...",
    rating: 5,
    reviewerName: "Jermaine H.",
    createdAt: "2026-01-07",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A46e1686647cb4267b030034b679264c5y.jpg"]
  },
  {
    id: "review-cc8ec63a",
    title: "",
    body: "Very pretty! Recommended.",
    rating: 5,
    reviewerName: "Landon G.",
    createdAt: "2025-11-25",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A58e14f9283504d23a1aa479c77ca22e6A.jpg"]
  },
  {
    id: "review-9b83b3d2",
    title: "",
    body: "Nicely made bracelet, lovely weave.. I bought it because of hand pain, I hope it will bring relief.",
    rating: 5,
    reviewerName: "Ernest C.",
    createdAt: "2025-07-23",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/Accbe4633028c437fa2b28ff3e1b228d0r.jpg"]
  },
  {
    id: "review-dd2c28ea",
    title: "",
    body: "Same as shown. Delivery time also fast, I recommend. Will buy again. Excellent quality 👌 Good communication.",
    rating: 4,
    reviewerName: "Bennett F.",
    createdAt: "2025-05-04",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A3a51bbbae0624c74bc082ec58903ae55n.jpg"]
  },
  {
    id: "review-19a89d13",
    title: "",
    body: "Arrived within a week. Same as the photo. Very nice. A bit heavier than expected but still nice!",
    rating: 5,
    reviewerName: "Dana C.",
    createdAt: "2026-01-22",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A0142810bade64e6988884b16006d76c0R.jpg"]
  },
  {
    id: "review-47cd9c4a",
    title: "",
    body: "Okay, thank you. I will use it well.",
    rating: 5,
    reviewerName: "Arlyne H.",
    createdAt: "2025-02-19",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/Ad9da46f3bc334782a326392afab95d85g.jpg"]
  },
  {
    id: "review-d6c90552",
    title: "",
    body: "It looks wow, I am crazy about its beauty. I will order for more.",
    rating: 5,
    reviewerName: "Marleen G.",
    createdAt: "2026-01-23",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/Ad7ac1c3f8da04c679d77ce58744cf3154.jpg"]
  },
  {
    id: "review-c8aaa7d1",
    title: "",
    body: "Good",
    rating: 5,
    reviewerName: "Millard S.",
    createdAt: "2025-03-25",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/Aaa20e11119724223a4ff45400b172a14d.jpg"]
  },
  {
    id: "review-a3daec76",
    title: "",
    body: "Beautiful bracelet and ring set, exactly as pictured.",
    rating: 5,
    reviewerName: "Linwood T.",
    createdAt: "2025-10-10",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A34e341615e7d41efb6963b134a660cbdg.jpg"]
  },
  {
    id: "review-ca8d5770",
    title: "",
    body: "Nice quality set, happy with my purchase.",
    rating: 4,
    reviewerName: "Dusty P.",
    createdAt: "2025-09-23",
    verified: true,
    productHandle: "calmi-set™-adjustable-twisted-copper-magnetic-bracelet-and-ring-for-everyday-balance",
    pictureUrls: ["https://ae01.alicdn.com/kf/A8cfc1838b3474657bbcb1e6466631f55W.jpg"]
  },
  
  // quartz-harmony™
  {
    id: "review-1f4016a2",
    title: "",
    body: "The chakra healing stones are worth the price 💯 🔥 🫡",
    rating: 5,
    reviewerName: "Jack J.",
    createdAt: "2025-07-16",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/A86e7d662a265489384f8148010f12c84V.jpg"]
  },
  {
    id: "review-90668b02",
    title: "",
    body: "Very cute box and set up. They are a bit smaller than I realized but the price is more than fair. The packing was done very well and it arrived faster than expected.",
    rating: 4,
    reviewerName: "Trinity H.",
    createdAt: "2025-10-03",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/A88fe0fbf4fc64d4f8e46eee6a166195e7.jpg"]
  },
  {
    id: "review-6ceb2455",
    title: "",
    body: "Stones are beautiful and packaged nicely. Smaller than I expected by pictures.",
    rating: 4,
    reviewerName: "Edmond R.",
    createdAt: "2025-08-06",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/Af35065bc41f2483ba48ffcd867c9f095c.jpg"]
  },
  {
    id: "review-c208d96e",
    title: "",
    body: "First time using this app and I was honestly expecting something else to come or have it be fake but it's actually 100% real. Came in a really cute box wrapped in bubble wrap. Came earlier than expected too!",
    rating: 5,
    reviewerName: "Denna W.",
    createdAt: "2025-11-01",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/A3250af6619dd427f832c89ce2a99bb68n.jpg"]
  },
  {
    id: "review-df59df4d",
    title: "",
    body: "Got it for my hubby and absolutely love them so cool and cute must buy if you ask me no joke ❣️ thanks guys....",
    rating: 5,
    reviewerName: "Mikel E.",
    createdAt: "2025-02-09",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/A2062b68b9305453db0317000ff88fc34N.jpg"]
  },
  {
    id: "review-a709a970",
    title: "",
    body: "A little small but cute for gift or collection.",
    rating: 5,
    reviewerName: "Rubin F.",
    createdAt: "2025-04-01",
    verified: true,
    productHandle: "quartz-harmony™-14-piece-pointed-quartz-crystal-set-for-meditation-chakra-balance-and-home-decor",
    pictureUrls: ["https://ae01.alicdn.com/kf/A2d4f15d120d741208f142f43be9297800.jpg"]
  },
  // calmi-chakra™ and other bracelets
  {
    id: "review-chakra-01",
    title: "",
    body: "Bracelet magnifique ! Les pierres sont vraiment belles et le bracelet est très confortable. Parfait pour la méditation.",
    rating: 5,
    reviewerName: "Sophie M.",
    createdAt: "2026-01-15",
    verified: true,
    productHandle: "calmi-chakra™-adjustable-7-chakra-crystal-bracelet-for-meditation-mindful-balance",
    pictureUrls: []
  },
  {
    id: "review-chakra-02",
    title: "",
    body: "Exactly as pictured. Beautiful colors and feels very calming to wear. Fast shipping too!",
    rating: 5,
    reviewerName: "Emma L.",
    createdAt: "2026-01-10",
    verified: true,
    productHandle: "calmi-chakra™-adjustable-7-chakra-crystal-bracelet-for-meditation-mindful-balance",
    pictureUrls: []
  },
  {
    id: "review-chakra-03",
    title: "",
    body: "J'adore ce bracelet ! Les 7 chakras sont bien représentés et le bracelet s'ajuste parfaitement.",
    rating: 4,
    reviewerName: "Marie D.",
    createdAt: "2025-12-28",
    verified: true,
    productHandle: "calmi-chakra™-adjustable-7-chakra-crystal-bracelet-for-meditation-mindful-balance",
    pictureUrls: []
  },
  {
    id: "review-chakra-04",
    title: "",
    body: "Great quality bracelet. I wear it every day for my meditation practice. Highly recommend!",
    rating: 5,
    reviewerName: "Lucas P.",
    createdAt: "2025-12-20",
    verified: true,
    productHandle: "calmi-chakra™-adjustable-7-chakra-crystal-bracelet-for-meditation-mindful-balance",
    pictureUrls: []
  },
  {
    id: "review-boho-01",
    title: "",
    body: "Beautiful agate bracelet! The purple color is stunning and it's very comfortable to wear.",
    rating: 5,
    reviewerName: "Julie R.",
    createdAt: "2026-01-12",
    verified: true,
    productHandle: "boho-agate™-vintage-purple-fire-agate-beaded-bracelet-unisex-elastic-jewelry",
    pictureUrls: []
  },
  {
    id: "review-boho-02",
    title: "",
    body: "Très joli bracelet bohème. Les perles sont magnifiques et le style vintage est parfait.",
    rating: 5,
    reviewerName: "Antoine B.",
    createdAt: "2025-12-18",
    verified: true,
    productHandle: "boho-agate™-vintage-purple-fire-agate-beaded-bracelet-unisex-elastic-jewelry",
    pictureUrls: []
  },
];

// Helper function to get reviews by product handle - improved matching logic
export function getReviewsByProduct(productHandle: string): Review[] {
  const normalizedHandle = productHandle.toLowerCase().replace(/[™®©]/g, '');
  
  return reviewsData.filter(review => {
    const normalizedReviewHandle = review.productHandle.toLowerCase().replace(/[™®©]/g, '');
    
    // Direct match
    if (normalizedReviewHandle === normalizedHandle) return true;
    
    // Partial match - check if either contains a significant part of the other
    const handleParts = normalizedHandle.split('-').filter(p => p.length > 3);
    const reviewParts = normalizedReviewHandle.split('-').filter(p => p.length > 3);
    
    // Check for common keywords
    const commonKeywords = ['calmi', 'ring', 'bracelet', 'set', 'chakra', 'tree', 'quartz', 'copper', 'magnetic'];
    const handleKeywords = handleParts.filter(p => commonKeywords.some(k => p.includes(k)));
    const reviewKeywords = reviewParts.filter(p => commonKeywords.some(k => p.includes(k)));
    
    // If both have matching keywords, consider it a match
    const matchingKeywords = handleKeywords.filter(hk => 
      reviewKeywords.some(rk => hk.includes(rk) || rk.includes(hk))
    );
    
    return matchingKeywords.length >= 2;
  });
}

// Get all reviews
export function getAllReviews(): Review[] {
  return reviewsData;
}

// Calculate stats
export function getReviewStats(reviews: Review[]) {
  const totalReviews = reviews.length;
  const averageRating = totalReviews > 0 
    ? Number((reviews.reduce((acc, r) => acc + r.rating, 0) / totalReviews).toFixed(1))
    : 0;
    
  const ratingBreakdown = [5, 4, 3, 2, 1].map(stars => ({
    stars,
    count: reviews.filter(r => r.rating === stars).length,
    percent: totalReviews > 0 
      ? Math.round((reviews.filter(r => r.rating === stars).length / totalReviews) * 100)
      : 0,
  }));
  
  return { averageRating, totalReviews, ratingBreakdown };
}

// Format date for display
export function formatReviewDate(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Aujourd'hui";
  if (diffDays === 1) return "Hier";
  if (diffDays < 7) return `Il y a ${diffDays} jours`;
  if (diffDays < 30) return `Il y a ${Math.floor(diffDays / 7)} semaine${Math.floor(diffDays / 7) > 1 ? 's' : ''}`;
  if (diffDays < 365) return `Il y a ${Math.floor(diffDays / 30)} mois`;
  return `Il y a ${Math.floor(diffDays / 365)} an${Math.floor(diffDays / 365) > 1 ? 's' : ''}`;
}
